import LanguageIcon from './LanguageIcon';

export default LanguageIcon;
